import { render, staticRenderFns } from "./ChpcValues.vue?vue&type=template&id=56030b7e&scoped=true&"
import script from "./ChpcValues.vue?vue&type=script&lang=js&"
export * from "./ChpcValues.vue?vue&type=script&lang=js&"
import style0 from "./ChpcValues.vue?vue&type=style&index=0&id=56030b7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56030b7e",
  null
  
)

export default component.exports